export const getExtension = (fileName: string): string | undefined => {
  if (fileName.indexOf(".") < 0) {
    return undefined;
  } else {
    return fileName.split(".").pop();
  }
};
